exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mode-active[data-v-7b098076] {\n  opacity: 0.65 !important;\n}\n", ""]);

// exports
